import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ConfigService } from 'src/app/services/config/config.service';
import { UserDataService } from 'src/app/services/user-data-service';
import { RefineryPresenceService } from 'src/app/services/refinery-presence.service';
import { MatTableDataSource } from '@angular/material/table';
import { ExportColumnInfo } from 'src/app/viewModels/exportViewModel';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { BaseComponent } from 'src/app/base/base.component';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { OptionItem } from 'src/app/model/optionItem';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CryptoService } from 'src/app/services/crypto.service';
import { FileBrowserDialogComponent } from '../../file-browser-dialog/file-browser-dialog.component';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { FolderBrowserDialogComponent } from '../../folder-browser-dialog/folder-browser-dialog.component';
import { DatePipe } from '@angular/common';
import { JsonDownloadService } from 'src/app/services/json-download.service';
import { ContainsTextDialogOptionComponent } from '../../shared/contains-text-dialog-option/contains-text-dialog-option.component';
import { ColoredTextItem } from 'src/app/domainObjects/coloredTextItem';
import { CacheKeyType, PreviewType } from 'src/app/domainObjects/transformType';
import { NodeRunStatus } from 'src/app/domainObjects/nodeRunStatus';
import { max } from 'rxjs';
import { FtpConnectionStatus, ftpNotReadyMessage } from 'src/app/views/shared/ftp-service-select/ftp-service-select.component';

/** Writer types that can write to an organization SFTP service ("Use FTP"). */
const FTP_UPLOAD_WRITER_TYPES = ['file', 'excel', 'feather', 'parquet'];

/**
 * Saved per writer item as `ftp`. With useFtp on, the writer's Export Directory is a
 * folder on the selected service. Only the service id is stored, never credentials.
 */
export interface DataWriterFtpSettings {
  useFtp: boolean;
  ftpServiceId: number | null;
}

export class JsonFormData {
  type: string;
  subtype: string;
  connstatus: string;
  tablename: string;
  targetcolumnskeyfields: string[] = [];
  primarykeyvalue:string;
  parameters:JsonFormDataValue[];
  outputcolumnlist:ExportMapColumnInfo[];
  isSelectAll: boolean = false;
  isUseSource: boolean = true;
  /** File writers only: write the output to an organization SFTP service. */
  ftp?: DataWriterFtpSettings;
}
export class JsonFormDataValue {
  name: string;
  ukey: string;
  value: string;
}
export class TestDataWriterRequest {
  type: string;
  subtype: string;
  parameters:JsonFormDataValue[];
  /** File writers with Use FTP on: test the Export Directory on this SFTP service. */
  ftp?: DataWriterFtpSettings;
  /** Scopes the FTP service lookup to the refinery's organization. */
  refineryConfigID?: string;
}
export class TestDataWriterResponse {
  message: string;
  status: string;
  tables_with_columns:tablecolumns[];
  inserted_records_count: number;
  updated_records_count:number;

}
export class tablecolumns {
  name: string;
  columns: columns[];
  primary_key_col :[string];
}
export class columns {
  name: string;
  datatype: string;
  
}
export class DataWriterMapRequest {
  nodeID: string;
  refineryConfigID: string;
  columnMapperType:number;
  tableName:string;
}
export class OutputCoulumnRequest {
  nodeId: string;
  farmType: string;
  orgId: string;
  userId: string;
  refineryId: string;
  cacheKeyType: number;
}
export class OutputCoulumnResponse {
  status: string;
  outputColumnList:OutputCoulumns[];
}
export class PartitionCoulumnRequest{
  nodeId: string;
  farmType: string;
  orgId: string;
  userId: string;
  refineryId: string;
  cacheKeyType: number;
  maxPartitions: number;
}
export class PartitionCoulumnResponse{
  status: string;
  partitionColumnsList:PartitionCoulumns[];
}

export class OutputCoulumnsMappingsResponse {
  status: string;
  outputColumnList:OutputCoulumnsMappings[];

}
export class OutputCoulumnsMappings {
  dataType: string;
  description: string;
  Field: string;
  index:number; 
  name:string;
  isinclude?: boolean;
  targetcolumn?: string;  // Added target column mapping
}
export class OutputCoulumns {
  DataType: string;
  Description: string;
  Field: string;
  index:number; 
  name:string;
}
export class PartitionCoulumns {
  DataType: string;
  Description: string;
  Field: string;
  index:number; 
  uniqueCount:string;
}


export class ExportMapColumnInfo {
  index: number;
  name: string;
  dataType: string;
  description: string;
  isinclude?: boolean;
  targetcolumn:string;

  constructor(index: number, name: string, dataType: string, description: string, isinclude: boolean,targetcolumn:string) {
    this.index = index;
    this.name = name;
    this.dataType = dataType;
    this.description = description;
    this.isinclude = isinclude;
    this.targetcolumn = targetcolumn;
  }
}
export class TestWriterRequest {
  nodeID: string;
  refineryConfigID: string;
  userId: string;
  orgId: string;
  refineryId: string;
  nodeId: string;
  transformId: string;
  cacheKeyType:CacheKeyType;
  // See RunrefineryRequest.tabId — same purpose: lets the Flask engine
  // check this call against the refinery's Edit-lock presence file.
  tabId: string;

}
@Component({
    selector: 'app-export-output-data-dynamic',
    templateUrl: './export-output-data-dynamic.component.html',
    styleUrls: ['./export-output-data-dynamic.component.css'],
    standalone: false
})
export class ExportOutputDataDynamicComponent extends BaseComponent implements OnInit{

  @Input() outputcolumncount: number = 0;
  isShowedForm: boolean = false;
  /** The selected file writer's Use FTP settings (the writer item's own `ftp` object). */
  dwFtp: DataWriterFtpSettings | null = null;
  /** Connection test state of the selected FTP service; Write Data Now waits for 'success'. */
  ftpConnectionStatus: FtpConnectionStatus = 'none';
  form: FormGroup;
  formGroup : { [key: string]: any } = {};
  exportcolumninfo: ExportMapColumnInfo[];

  formConfigjson: any[]=[];
  formConfigjsonNext: any[]=[];
  formConfigjsonNextButton: any[]=[];
  
  isRunWriter: boolean=false;
  hdn:string="hdn";
  selectedType:string="";
  selectedSubType:string="";
  selectedSavedType:string="";
  selectedSavedSubType:string="";
  jsonFormData:JsonFormData[]=[];
  jsonFormDataValue:JsonFormDataValue[]=[];
  isdbmapping: boolean = false;
  width:string="349px";
  targettables:OptionItem[]=[];
  filteredTables: OptionItem[] = []; // Ensure filteredTables is initialized

  targetcolumns:OptionItem[];
  targetcolumns_without_datatype:OptionItem[];
  targetcolumnsValues:OptionItem[];
  selectedtable:string="";
  targetcolumnskeyfields: string[] = [];
  primarykeyvalue:string='';

  updatedRows: number = 0;
  insertedRows: number = 0;
  showStatusPanel: boolean = false; // Initially hidden

  testconnresponse:TestDataWriterResponse; 
  dataSourceExport: MatTableDataSource<any>;
  displayedColumnsExport: string[] = ['order','include', 'name', 'dataType', 'description'];
  timeOut:number=5;
  heightelement:number=10;
  isConnectionValid :boolean=false;
  options: string[] =[];
  disabledColumns:any;
  defaultTargetColumn = 'Select a Target Column';
  partitionColumnOptions: { value: string; text: string }[] = [];
  selectedPartitionColumns: string[] = [];
  isSelectAll = false;
  isUseSource = true;
  isDisabled = false;
  selectdynamicsource: { value: string; text: string }[] = [];
  @ViewChildren('targetInput') inputs!: QueryList<ElementRef>;
  @Output() moveToNextField = new EventEmitter<'forward' | 'reverse'>();
  
  constructor(
    errorService: ErrorReportingService,
    matDialog: MatDialog,
    private formBuilder: FormBuilder,
    private configService: ConfigService,
    private userData: UserDataService,
    private cdRef: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    private cryptoService: CryptoService,
    public datePipe: DatePipe,
    private jsonDownloadService: JsonDownloadService,
    private refineryPresence: RefineryPresenceService
  ) { super(errorService, matDialog);}
  async ngOnInit() {
  }
  async initializeExportComponent() {
    console.log("run the writer code");
    this.formConfigjson = await this.configService.getDataWriterConfig(); 
   // console.log("this.formConfigjson==",this.formConfigjson);     
    this.formConfigjson =this.formConfigjson.sort((a,b)=>a.order-b.order);
    await this.createDataWriterJson();

    var currentConfig = this.userData.getSelectedRefineryDetails().guid ;
    const configJson = await this.configService.getRefineryConfigByGuidAsync(currentConfig);
    this.userData.setSelectedRefineryDetails(configJson);

    var node=configJson.nodes.find(node=>node.id==this.userData.getSelectedNodeDetails().id);
    if(node.data.dataWriter){
      await this.assignToDataWriterJson(node.data.dataWriter);
      //saved selected prev data
      this.selectedSavedType=node.data.dbWriterType;
      this.selectedSavedSubType=node.data.dbWriterSubType;
//console.log("node.data.timeout ",node.data);
      this.isRunWriter=node.data.isdbupdater;
      this.selectedType=node.data.dbWriterType;
      this.selectedSubType=node.data.dbWriterSubType;
      this.timeOut=node.data.timeOut;
      //click in Type mannually if selected
      var field=this.formConfigjson.find(x=>x.value==this.selectedType);
   //   console.log("prajna field check:=",field)
      await this.bindJsonForm(field);
      if(this.selectedType!=this.selectedSubType){
        var field=this.formConfigjsonNextButton.find(x=>x.value==this.selectedSubType);
        if(field){
          this.bindJsonFormNext(field);
        }
      }       
    }
    console.log("completed run the writer code");
  }
  showNext(field:any){
    if(this.selectedSavedType==field.value){
      this.selectedType=this.selectedSavedType;
      this.selectedSubType=this.selectedSavedSubType;
      this.bindJsonForm(field);
      var field=this.formConfigjsonNextButton.find(x=>x.value==this.selectedSubType);
        if(field){
          this.bindJsonFormNext(field);
        }
    }
    else{
      this.selectedType=field.value;
      this.selectedSubType=field.value;
      this.bindJsonForm(field);
    }
    // this.selectedType=field.value;
    // this.selectedSubType=field.value;
    // this.bindJsonForm(field);
  }
  async bindJsonForm(field:any){
    this.isShowedForm=true;
    this.bindDwFtpSettings();
    if(field.form.length!=0){
      this.formConfigjsonNext=field.form.filter(x=>x.type!='button').sort((a: { order: number; },b: { order: number; })=>a.order-b.order);
      this.formConfigjsonNextButton=field.form.filter(x=>x.type=='button').sort((a: { order: number; },b: { order: number; })=>a.order-b.order);
      
      if(this.formConfigjsonNext.length!=0){
        this.buildJsonForm();
      }
    }
    this.bindData(field.isdbmapping);
  }
  bindJsonFormNext(field:any){
   // console.log("prajna bind json");
    this.selectedSubType=field.value;
    this.formConfigjsonNext=field.form.sort((a: { order: number; },b: { order: number; })=>a.order-b.order);
    //this.testConnection();
    this.buildJsonForm();
    this.bindData(field.isdbmapping);
  }
   
  
 buildJsonForm(): void {
    this.formConfigjsonNext.filter(x=>x.type!='button').forEach(field => {
      var value=field.value;
  

      var basename="";
      //set default value
      if(field.ukey=="2"){
        basename=this.userData.getSelectedNodeDetails().name+" "+this.userData.getSelectedNodeDetails().farmtypename;
      }
      else if(field.ukey=="9"){
        basename=this.userData.getSelectedNodeDetails().name+" "+this.userData.getSelectedNodeDetails().farmtypename;
      }
      //set data from saved json
      if(this.jsonFormData){
        var parameters=this.jsonFormData.find(x=>x.type==this.selectedType && x.subtype==this.selectedSubType).parameters;
        var fieldvalue=parameters.find(p=>p.name==field.name);
        if(fieldvalue){
          if(fieldvalue.ukey=="16"){
            value=this.cryptoService.decryptUsingAES256(fieldvalue.value).toString();
          }
          else if(fieldvalue.ukey=="9"){
            // filename will be set by updateFileName() after form is built
            value="";
          }
          else{
            value=fieldvalue.value;
          }
        }
        if(value==""){
          if(fieldvalue.ukey=="2"){
            value=basename;
          }
          else if(fieldvalue.ukey=="9"){
            // filename will be set by updateFileName() after form is built
          }
          else if(fieldvalue.ukey=="0"){
            value='currentDateTime';
          }
        }
      }
      if(field.ukey=="9"){
        //this.formGroup[field.name] = new FormControl(value);
        field.value=value;
      }
      if (field.type === 'multiselect') {
        const defaultValue = (typeof field.value === 'string' && field.value !== '') ? field.value : '';
        this.formGroup[field.name] = new FormControl(defaultValue);
      }

      if (field.type === "toggle") {
      // ✅ Toggle: default to false unless explicitly true
        const toggleValue = (value === true || value === "true");
        this.formGroup[field.name] = new FormControl(toggleValue);
      }
      else if (field.type === "selectdynamic") {
        this.formGroup[field.name] = new FormControl(value);
      }
      else{
        this.formGroup[field.name] = new FormControl(value, Validators.required);
        if(field.name == 'overwriteMode' && value == 'append') {
           setTimeout(() => {
            this.isDisabled = true;
            //this.cdRef.detectChanges();
           }, 100);

        } else {
            this.isDisabled = false;
        } 
      }
    });

    
    //console.log("rr this.formConfigjsonNext...."+JSON.stringify(this.formConfigjsonNext))
    this.form = this.formBuilder.group(this.formGroup);
    
    // Set filename using updateFileName after form is built
    const basenameField = this.formConfigjsonNext.find(f => f.ukey == "2");
    const basename = basenameField ? (this.form.get(basenameField.name)?.value || this.userData.getSelectedNodeDetails().name+" "+this.userData.getSelectedNodeDetails().farmtypename) : '';
    this.updateFileName(basename);
  }
 
 
    

    async testConnection() {
      const ftpError = this.dwFtpValidationError(false);
      if (ftpError) {
        this.displayWarning(ftpError, "Please fix the validation error.", "", (onClosed) => {});
        return;
      }
      const busyIndicator = this.showBusyDialog('Please wait...');
      try {
        var selectedform = this.jsonFormData.find(
          x => x.type == this.selectedType && (x.subtype == this.selectedSubType || x.subtype == this.selectedType)
        );
    
        var tdr = new TestDataWriterRequest();
        tdr.type = selectedform.type;
        tdr.subtype = selectedform.subtype;
        tdr.parameters = [];
        if (this.isFtpUploadWriter && this.dwFtp?.useFtp) {
          tdr.ftp = { ...this.dwFtp };
          tdr.refineryConfigID = this.userData.getSelectedNodeDetails().refineryConfigGuid;
        }
    
        selectedform.parameters.forEach(m => {
          if (this.form.value[m.name]) {
            if (m.ukey == "16") {
              m.value = this.cryptoService.encryptUsingAES256(this.form.value[m.name].toString());
            } else {
              m.value = this.form.value[m.name].toString();
            }
          }
          tdr.parameters.push(m);
        });
    
        this.testconnresponse = await this.configService.dataWriterTestConnection(tdr);
        selectedform.connstatus = this.testconnresponse.status;
        selectedform.outputcolumnlist = this.exportcolumninfo;
       //console.log("column list in test connection==",  selectedform.outputcolumnlist);
    
        if (this.testconnresponse.status == "success") {
          this.isConnectionValid =true;
          this.snackBar.open(this.testconnresponse.message, 'Dismiss', { duration: 5000 });

          this.targetcolumnskeyfields = [];
          this.primarykeyvalue='';
          this.selectedColumns = [];
          // **Set default "Select a table" as the first option**
          this.targettables = [
            new OptionItem('', 'Select a table', true), 
            ...this.testconnresponse.tables_with_columns.map(opt => new OptionItem(opt.name, opt.name, false))
          ];
    
          // **Set selectedtable to default blank value ("Select a table")**
          this.selectedtable = '';
    
        } else {
          this.displayError(this.testconnresponse.message, 'Failed to Test Connection.');
        }
    
        await this.onSubmit();
        await this.initializeExportComponent();
        busyIndicator.close();
      } catch (err) {
        busyIndicator.close();
        this.displayError('Failed to Test Connection.', 'Error', err);
      }
    }
    
 
    onSelectionChange(event: any) {
      // Reset key fields and column selections
      this.targetcolumnskeyfields = [];
      this.primarykeyvalue = '';
      this.selectedColumns = [];
    
      this.selectedtable = event.value;
      this.targetcolumns = [];
      this.targetcolumns_without_datatype=[];
      this.targetcolumnsValues = [];
    
      // Find the selected table object
      var selectedTable = this.testconnresponse.tables_with_columns.find(
          (c: any) => c.name === event.value
      );
  
      if (selectedTable) {
          // Extract primary key columns as a Set for quick lookup
          const primaryKeyColumns = new Set(selectedTable.primary_key_col || []);
  
          // Populate `targetcolumns` (Keep all columns)
          selectedTable.columns.forEach((col: any) => {
              this.targetcolumns.push(new OptionItem(col.name, `${col.name}`, false));
            this.targetcolumns_without_datatype.push(new OptionItem(col.name, `${col.name}`, false));
          });
  
          // Populate `targetcolumnsValues` (Exclude primary key columns)
          selectedTable.columns
              .filter((col: any) => !primaryKeyColumns.has(col.name)) // Remove primary key columns
              .forEach((col: any) => {
                  this.targetcolumnsValues.push(new OptionItem(col.name, col.name, false));
              });


              this.disabledColumns = this.exportcolumninfo.map(item => item.targetcolumn ?? '');
             // console.log("disabled columns=", this.disabledColumns);
              
            /*  this.options = [
                ...this.targetcolumns_without_datatype
                  .map(col => col.value)
                  .sort((a, b) => a.localeCompare(b))
              ];
              
              console.log("options columns=", this.options);*/
            //  console.log("options targetcolumns=", this.targetcolumns);
              this.options = [
                ...this.targetcolumns
                  .map(col => col.text)
                  .sort((a, b) => a.localeCompare(b))
              ];

          // Convert primary key array to a comma-separated string
          this.primarykeyvalue = selectedTable.primary_key_col.length > 1
              ? selectedTable.primary_key_col.join(', ')
              : selectedTable.primary_key_col[0] || ''; // Handle empty case
      }
  }
  
    onTargetColumnChanged(value: ExportMapColumnInfo, event: any): void {
       if (value.name) {
       this.getDisabledColumns();
       }
     }
    getDisabledColumns(){
      this.disabledColumns = this.exportcolumninfo.map(item => item.targetcolumn ?? '');
     // console.log("disabled columns=", this.disabledColumns);
    }
    handleMoveToFieldOld(direction: 'forward' | 'reverse', index: number) {
      if (direction  === 'reverse') {
        this.focusPreviousInputOld(index);
      } else {
        this.focusNextInputOld(index);
      }
    }
  
    focusNextInputOld(index: number) {
      const nextElement = document.querySelectorAll('app-autocomplete-field input')[index + 1];
      if (nextElement) {
        (nextElement as HTMLElement).focus();
      }
    }
    focusPreviousInputOld(index: number) {
      const previousElement = document.querySelectorAll('app-autocomplete-field input')[index - 1];
      if (previousElement) {
        (previousElement as HTMLElement).focus();
      }
    }
    
  async onSubmit() {   
    var selectedform=this.jsonFormData.find(x=>x.type==this.selectedType && (x.subtype==this.selectedSubType || x.subtype==this.selectedType));
    selectedform.tablename=this.selectedtable;
    selectedform.targetcolumnskeyfields=this.targetcolumnskeyfields;
    selectedform.primarykeyvalue=this.primarykeyvalue;
    selectedform.isSelectAll=this.isSelectAll;
    selectedform.isUseSource=this.isUseSource;
    this.jsonFormDataValue=[];
    selectedform.parameters.forEach(m => {
      if(this.form.value[m.name]){
        if(m.ukey=="16"){
          m.value=this.cryptoService.encryptUsingAES256(this.form.value[m.name].toString());
        }else{
          m.value=this.form.value[m.name].toString();
        }
      }
    });
    selectedform.outputcolumnlist=this.exportcolumninfo;

    var configJson=this.userData.getSelectedRefineryDetails();
    var confignode=configJson.nodes.find(node=>node.id==this.userData.getSelectedNodeDetails().id);
    confignode.data.dbWriterType=this.selectedType;
    confignode.data.dbWriterSubType=this.selectedSubType;
    confignode.data.isdbupdater=this.isRunWriter;
    confignode.data.dataWriter=this.jsonFormData;
    confignode.data.timeOut=this.timeOut;
    
    await this.configService.UpsertRefineryConfig(configJson);
  }
  //create json for saving in node config from json form
  async createDataWriterJson() {
    this.jsonFormData=[];
    var formConfigjsonbutton=this.formConfigjson.filter(x=>x.type=="button");
    formConfigjsonbutton.forEach(item => {
      var type=item.value;
      var subtype="";
      var subtypebuttons=item.form.filter(b=>b.type=="button");
      if(subtypebuttons.length>0){
        subtypebuttons.forEach(sm => {
          subtype=sm.value;
          this.jsonFormDataValue=[];
          sm.form.forEach(m => {
            if(m.type!='button'){
              this.jsonFormDataValue.push({name:m.name,ukey:m.ukey,value:m.value.toString()});
            }
          });
          this.jsonFormData.push({type:type,subtype:subtype,connstatus:"notdone",tablename:"",targetcolumnskeyfields:this.targetcolumnskeyfields,primarykeyvalue:this.primarykeyvalue,parameters:this.jsonFormDataValue,outputcolumnlist: [],isSelectAll: this.isSelectAll,isUseSource:this.isUseSource});
        });
      }
      else{
        subtype=type;
        this.jsonFormDataValue=[];
        item.form.forEach(m => {
          if(m.type!='button'){
            this.jsonFormDataValue.push({name:m.name,ukey:m.ukey,value:m.value.toString()});
          }
        });
        this.jsonFormData.push({type:type,subtype:subtype,connstatus:"notdone",tablename:"",targetcolumnskeyfields:this.targetcolumnskeyfields,primarykeyvalue:this.primarykeyvalue,parameters:this.jsonFormDataValue,outputcolumnlist: [],isSelectAll: this.isSelectAll,isUseSource:this.isUseSource});
      }
    });
  }
  //assign saved json data to jsonFormData and form config
  async assignToDataWriterJson(prevalues:any) {
    this.jsonFormData.forEach(item => {
      var values=prevalues.find(x=>x.type=item.type && x.subtype==item.subtype);
      item.connstatus=values.connstatus;
      item.tablename=values.tablename;
      item.targetcolumnskeyfields=values.targetcolumnskeyfields;
      item.primarykeyvalue=values.primarykeyvalue;
      item.isSelectAll=values.isSelectAll;
      item.isUseSource=values.isUseSource;      
      item.tablename=values.tablename;
      item.ftp=values.ftp;
      if(item.parameters.length > 0) 
      {
         item.parameters.forEach(m => {
          var value=values.parameters.find(x=>x.name==m.name);
          if(value.value!=""){
            m.value=value.value;
          }
        });
        item.outputcolumnlist=values.outputcolumnlist;
      }
    });
    //for form config and conn status
    this.formConfigjson.filter(x=>x.type=='button').forEach(field => {
      var type=field.value;
      var connstatus=this.jsonFormData.find(x=>x.type==type && x.subtype==type);
      if(connstatus){
        field.connstatus=connstatus.connstatus;
      }
      field.form.filter(f=>f.type=='button').forEach(m => {
        var connstatus=this.jsonFormData.find(x=>x.type==type && x.subtype==m.value);
        if(connstatus){
          m.connstatus=connstatus.connstatus;
        }
      });
    });
  }

  get isFtpUploadWriter(): boolean {
    return FTP_UPLOAD_WRITER_TYPES.includes(this.selectedType);
  }

  /**
   * Points dwFtp at the selected file writer's own `ftp` settings (creating them
   * on first use), so edits are saved with that writer item by onSubmit and each
   * writer type keeps its own selection.
   */
  private bindDwFtpSettings(): void {
    // The FTP Service dropdown stays on screen (and doesn't re-announce its status)
    // when the same service is bound again - e.g. after Test Connection or Save
    // Config reload the writer config - so its last test result still applies.
    // Only a different (or no) service resets it.
    const previousServiceId = this.dwFtp?.useFtp ? this.dwFtp.ftpServiceId : null;
    if (!this.isFtpUploadWriter) {
      this.dwFtp = null;
      this.ftpConnectionStatus = 'none';
      return;
    }
    const item = this.jsonFormData?.find(x => x.type == this.selectedType && x.subtype == this.selectedType);
    if (!item) {
      this.dwFtp = null;
      this.ftpConnectionStatus = 'none';
      return;
    }
    item.ftp = {
      useFtp: !!item.ftp?.useFtp,
      ftpServiceId: item.ftp?.ftpServiceId ?? null
    };
    this.dwFtp = item.ftp;
    const sameService = item.ftp.useFtp && item.ftp.ftpServiceId != null && item.ftp.ftpServiceId === previousServiceId;
    if (!sameService) {
      this.ftpConnectionStatus = 'none';
    }
  }

  /**
   * The Export Directory means a local folder with Use FTP off and a folder on the
   * SFTP service with it on, so switching clears it rather than letting a path be
   * reinterpreted on the other file system.
   */
  onUseFtpToggled(): void {
    this.ftpConnectionStatus = 'none';
    this.clearExportDirectory();
  }

  /** A different service is a different server: its folders replace the old path. */
  onFtpServiceSelected(id: number | null): void {
    if (this.dwFtp.ftpServiceId != null && id != null && id !== this.dwFtp.ftpServiceId) {
      this.clearExportDirectory();
    }
    this.dwFtp.ftpServiceId = id;
  }

  private clearExportDirectory(): void {
    const directoryField = this.formConfigjsonNext?.find(f => f.ukey == '1');
    if (!directoryField) {
      return;
    }
    this.form?.get(directoryField.name)?.setValue('');
    // onSubmit only copies non-empty form values, so clear the saved value too.
    const item = this.jsonFormData?.find(x => x.type == this.selectedType && x.subtype == this.selectedType);
    const saved = item?.parameters?.find(p => p.ukey == '1');
    if (saved) {
      saved.value = '';
    }
  }

  /**
   * Why the FTP upload settings block saving (requireTested false) or writing
   * (requireTested true), or null when they don't.
   */
  private dwFtpValidationError(requireTested: boolean): string | null {
    if (!this.isFtpUploadWriter || !this.dwFtp?.useFtp) {
      return null;
    }
    if (this.dwFtp.ftpServiceId == null) {
      return 'Select an FTP service.';
    }
    return requireTested ? ftpNotReadyMessage(true, this.ftpConnectionStatus) : null;
  }

  toggleRunWriter(event: any): void {
    this.isRunWriter=event.checked;
  }
  dropExportColumnTable(event: CdkDragDrop<MatTableDataSource<ExportMapColumnInfo>>): void {
    const prevIndex = event.previousIndex;
    const currentItem: ExportMapColumnInfo = event.item.data;
    currentItem.index = prevIndex;
    moveItemInArray(this.exportcolumninfo, prevIndex, event.currentIndex);
    for (let i = 0; i < this.exportcolumninfo.length; i++) {
      this.exportcolumninfo[i].index = i + 1;
    }
    this.exportcolumninfo.sort((a, b) => a.index - b.index);
    this.dataSourceExport.data = this.exportcolumninfo;
  }
  onExportIncludeChanged(event: MatSlideToggleChange): void {
    this.exportcolumninfo.forEach(r => {
      if (!this.isPartitionSelected(r.name)) {
        r.isinclude = event.checked;
      }
    });
  }
  
  async onNumberFieldChange(field: any, event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    let value = +input.value;
    if (field.ukey === "13" && field.name === "maxpartitions") {
      if (value < 1) value = 1;
      if (value > 11) value = 11;
      input.value = String(value);
      this.form.get(field.name)?.setValue(value, { emitEvent: false });
      await this.loadPartitionColumns(value);
    } else {
      this.form.get(field.name)?.setValue(value, { emitEvent: false });
    }
  }

  private buildPartitionColumnRequest(maxPartitions: number): PartitionCoulumnRequest {
    const node = this.userData.getSelectedNodeDetails();
    const request = new PartitionCoulumnRequest();
    request.nodeId = node.id;
    request.farmType = node.farmtypename;
    request.orgId = this.userData.getOrgId();
    request.userId = this.userData.getUserId();
    request.refineryId = this.userData.getRefineryId();
    request.cacheKeyType = CacheKeyType.node;
    request.maxPartitions = maxPartitions;
    return request;
  }

  async loadPartitionColumns(maxPartitions: number): Promise<void> {
    const request = this.buildPartitionColumnRequest(maxPartitions);
    const partitioncolumnsResp: PartitionCoulumnResponse = await this.configService.getpartitioncolumns(request);
    console.log("partitioncolumns :", partitioncolumnsResp);
    this.partitionColumnOptions = [
       { value: 'none', text: 'None' },
       ...partitioncolumnsResp.partitionColumnsList.map(c => ({
        value: c.Field,
        text: c.Field +" ("+c.uniqueCount+")"
      }))
    ];
  }

  onPartitionColumnSelectionChange(selectedValue: string): void {
    this.selectedPartitionColumns = (selectedValue && selectedValue !== 'none') ? [selectedValue] : [];
  }

  isPartitionSelected(columnName: string): boolean {
    //console.log("check if partition selected for column:", columnName, this.selectedPartitionColumns);
    return this.selectedPartitionColumns.includes(columnName);
  }

  async bindData(isdbmapping:boolean): Promise<void> {
    try {
      //console.log("isdbmapping :",isdbmapping);
      this.isdbmapping=isdbmapping;
      const multiselectFields = this.formConfigjsonNext?.filter(f => f.type === 'multiselect') ?? [];
      this.selectedPartitionColumns = [];
      multiselectFields.forEach(f => {
        const val = this.form?.get(f.name)?.value;
        if (val && typeof val === 'string' && val !== 'none') {
          this.selectedPartitionColumns.push(val);
        }
      });

      var outputcoulumnrequest =new OutputCoulumnRequest();
      outputcoulumnrequest.nodeId=this.userData.getSelectedNodeDetails().id;
      outputcoulumnrequest.farmType=this.userData.getSelectedNodeDetails().farmtypename;
      outputcoulumnrequest.orgId=this.userData.getOrgId();
      outputcoulumnrequest.userId=this.userData.getUserId();
      outputcoulumnrequest.refineryId=this.userData.getRefineryId();
      outputcoulumnrequest.cacheKeyType=CacheKeyType.node;
      const outputcolumns = await this.configService.getoutputcolumns(outputcoulumnrequest);
      console.log("outputcolumns :",outputcolumns);
      //below code need to review later
      const timestampOptions = outputcolumns.outputColumnList.filter(col=>col.DataType=='Timestamp').map(c=>({value:c.Field,text:c.Field}));
      this.selectdynamicsource = [{ value: 'currentDateTime', text: 'currentDateTime' }, ...timestampOptions];
      const datetimeParam = this.jsonFormData?.find(x=>x.type==this.selectedType && x.subtype==this.selectedSubType)?.parameters?.find((p:any)=>p.ukey=='0');
      const savedDateValue = datetimeParam?.value || '';
      const defaultDateValue = savedDateValue !== '' ? savedDateValue : 'currentDateTime';
      const datetimeFieldConfig = this.formConfigjsonNext?.find(x=>x.ukey=='0');
      if (datetimeFieldConfig) {
        datetimeFieldConfig.value = defaultDateValue;
        // selectdynamicsource (above) is connector-specific and can change on every connector
        // switch. Re-validate whatever value is currently in the live DateTime Field control
        // against the freshly computed option list, and fall back to 'currentDateTime' (always
        // a valid option) if it's no longer selectable - otherwise a value carried over from a
        // previous connector (e.g. a timestamp column that only existed there) stays selected
        // even though the dropdown no longer offers it.
        const dateFieldControl = this.form?.get(datetimeFieldConfig.name);
        if (dateFieldControl && !this.selectdynamicsource.some(o => o.value === dateFieldControl.value)) {
          const staleValue = dateFieldControl.value;
          dateFieldControl.setValue('currentDateTime');
          if (staleValue) {
            this.displayWarning(
              `The previously selected DateTime Field "${staleValue}" is not available for this connector and has been reset to "currentDateTime". Please review the DateTime Field selection.`,
              'DateTime Field Reset'
            );
          }
        }
      }
      const partitionColumnFieldConfig = this.formConfigjsonNext?.find(x=>x.ukey=='13' && x.name=='maxpartitions');
      var maxPartitions = 0;
      
      if (this.selectedType === 'parquet') {
          const selectedRefineryDetails = this.userData.getSelectedRefineryDetails();
          console.log("selectedRefineryDetails for parquet:", selectedRefineryDetails);
          if (selectedRefineryDetails != null && selectedRefineryDetails != undefined) {
            const node = selectedRefineryDetails.nodes.find(n => n.id === this.userData.getSelectedNodeDetails().id);
            if (node != null && node != undefined) {
              console.log(node.data.dataWriter);
              if(node.data.dataWriter == undefined) {
                maxPartitions = partitionColumnFieldConfig ? parseInt(partitionColumnFieldConfig.value, 10) : 0;
              } else {
                const parquetDataWriters = node.data.dataWriter.filter(x => x.type === 'parquet');
                console.log("parquetDataWriters :", parquetDataWriters);
                const parquetDWParams = parquetDataWriters[0].parameters;
                const maxPartitionsObj = parquetDWParams.find((param: any) => param.ukey === '13');
                const partitionValue =
                maxPartitionsObj?.value?.trim() !== '' ? maxPartitionsObj?.value : partitionColumnFieldConfig.value;
                maxPartitions = parseInt(partitionValue, 10);  
              }
            }
          } else {
               maxPartitions = partitionColumnFieldConfig ? parseInt(partitionColumnFieldConfig.value) : 0;
          }
          await this.loadPartitionColumns(maxPartitions);
      }

      //set saved values
      var savedconfig=this.jsonFormData.find(x=>x.type==this.selectedType && x.subtype==this.selectedSubType);
      //console.log("savedconfig :",savedconfig);
      this.exportcolumninfo=[];
      outputcolumns.outputColumnList.forEach(ci=>{
        if(savedconfig){
          var value=savedconfig.outputcolumnlist.find(x=>x.name==ci.Field);
          if(!value){
            this.exportcolumninfo.push(new ExportMapColumnInfo(ci.index,ci.Field,ci.DataType,ci.Description,true,""));
          }
          else{
            this.exportcolumninfo.push(new ExportMapColumnInfo(value.index,ci.Field,ci.DataType,ci.Description,value.isinclude,value.targetcolumn));
          }
        }
        else{
          this.exportcolumninfo.push(new ExportMapColumnInfo(ci.index,ci.Field,ci.DataType,ci.Description,true,""));
        }
      });
      this.exportcolumninfo=this.exportcolumninfo.sort((a,b)=>a.index-b.index);
      var selectedform=this.jsonFormData.find(x=>x.type==this.selectedType && x.subtype==this.selectedSubType);
      // var selectedform=this.jsonFormData.find(x=>x.type==this.selectedType && x.subtype==this.selectedSubType);
       //console.log("selectedform==",selectedform);
      if(isdbmapping){
        //console.log("isdbmapping1 :",isdbmapping);
        this.displayedColumnsExport= ['order','include', 'name', 'dataType','targetcolumn', 'description'];
        if(this.targettables.length==0){
          var tdr=new TestDataWriterRequest();
          tdr.type=selectedform.type;
          tdr.subtype=selectedform.subtype;
          tdr.parameters=[];
          selectedform.parameters.forEach(m => {
            tdr.parameters.push(m);
          });
        
          this.testconnresponse = await this.configService.dataWriterTestConnection(tdr);
          this.targettables=[];
          this.testconnresponse.tables_with_columns.forEach(opt=>{
            this.targettables.push(new OptionItem(opt.name,opt.name,false))
          })
        }
      
        this.selectedtable=selectedform.tablename;
        console.log("check table name before run",this.selectedtable);
        this.onSelectionChange({ value: this.selectedtable });
    
       
        if(this.selectedtable!=""){
          this.targetcolumns=[];
          var tablecolumns=this.testconnresponse.tables_with_columns.find(c=>c.name==this.selectedtable);
          if(tablecolumns){
            tablecolumns.columns.forEach(col => {
              this.targetcolumns.push(new OptionItem(col.name,col.name,false))
            });
          }
        }
      }
      else{
        const sourceBasedTypes = ['file', 'excel', 'feather','parquet'];
        if(sourceBasedTypes.includes(this.selectedType)){
          
          this.displayedColumnsExport= ['order','include', 'name','entertargetcolumn', 'dataType', 'description'];
          console.log("savedconfig",savedconfig);
          if(savedconfig.parameters.find(x=>x.ukey=="1").value==''){
            console.log("savedconfig not found for source based type, setting default values for isSelectAll and isUseSource");
            this.isSelectAll=true;
            this.isUseSource=true;
            this.exportcolumninfo.forEach( r => r.targetcolumn = r.name);
          }else{
            this.isSelectAll=savedconfig.isSelectAll;
            this.isUseSource=savedconfig.isUseSource;
          }
        }else{
          this.displayedColumnsExport= ['order','include', 'name', 'dataType', 'description'];
        }
      }
      this.dataSourceExport = new MatTableDataSource<ExportMapColumnInfo>();
      this.dataSourceExport.data = this.exportcolumninfo;
      this.displayedColumnsExport = this.displayedColumnsExport;
       
      this.cdRef.detectChanges();
    } catch (err) {
      this.displayError('Failed to bind data.', 'Error', err);
    }
  }
  async testWriter() {
    var configJson= await this.configService.getRefineryConfigByGuidAsync(this.userData.getRefineryId());
    var confignode=configJson.nodes.find(node=>node.id==this.userData.getNodeId());
    if (confignode.data.nodeStatus!=NodeRunStatus.Completed) {
      const errorMsg = "The Node must be run before we can run the Data Writer and if there is data in the output preview, then run the writer.";
      this.displayError(errorMsg, "Warning");
      return; // Exit early
    }
    var selectedform=this.jsonFormData.find(x=>x.type==this.selectedType && (x.subtype==this.selectedSubType || x.subtype==this.selectedType));
    if(!selectedform){
      this.displayError(`You must configure the config settings before Write Data Now.`, 'Error');
      return; 
    } else {
       const directoryField = selectedform.parameters.find(p => p.ukey == "1");
       const directoryPath = this.form.value[directoryField.name];
       if (!directoryPath || directoryPath.trim() === '') {
          this.displayWarning("Please select a directory path.", "Please fix the validation error.", "", (onClosed) => {});
          return;
       } 
    }
    const ftpError = this.dwFtpValidationError(true);
    if (ftpError) {
      this.displayWarning(ftpError, "Please fix the validation error.", "", (onClosed) => {});
      return;
    }
    const busyIndicator = this.showBusyDialog('Please wait...');
    
    try {
        await this.onSubmit();
        var tws = new TestWriterRequest();
        const node = this.userData.getSelectedNodeDetails();
        tws.nodeID = node.id;
        tws.refineryConfigID = node.refineryConfigGuid;

        tws.userId = this.userData.getUserId();
        tws.orgId = this.userData.getOrgId();
        tws.refineryId = this.userData.getRefineryId();
        tws.nodeId = this.userData.getNodeId();
        tws.transformId = "";
        tws.tabId = this.refineryPresence.tabId;
        tws.cacheKeyType = CacheKeyType.node;


        var testwriter = await this.configService.testWriter(tws);
        
        if (testwriter.status === "Completed") {
            // Set updated and inserted rows dynamically
            this.updatedRows = testwriter.updated_records_count || 0;
            this.insertedRows = testwriter.inserted_records_count || 0;
            this.showStatusPanel = true; // Show the panel

            this.snackBar.open(testwriter.message, 'Dismiss', {
                duration: 5000
            });
        } else {
            this.displayError(`Failed to write '${this.selectedSubType}'`, 'Error', testwriter.message);
            this.showStatusPanel = false; // Hide panel on failure
        }

        busyIndicator.close();
    } catch (err) {
        busyIndicator.close();
        this.displayError(`Failed to write '${this.selectedSubType}'`, 'Error', err);
        this.showStatusPanel = false; // Hide panel on failure
    }
}

async saveConfig() {
  if(this.isdbmapping)
  {
    // **Step 1: Check if Table is Blank**
    if (!this.selectedtable) {
      console.log("Table is missing - showing warning");
      this.displayWarning("Please select a table.", "Please fix the validation error.", "", (onClosed) => {});
      return;
    }
    console.log("Table is selected, proceeding to check key fields.");
    if ((!this.primarykeyvalue || this.primarykeyvalue.trim() === '') && 
    (!this.targetcolumnskeyfields || this.targetcolumnskeyfields.length === 0)) {
        console.log("Key fields are missing - showing warning");
        this.displayWarning(
          "Please select at least one additional key field.", 
            "Please fix the validation error.", 
            "", 
            (onClosed) => {}
        );
        return;
    }
  }
  var selectedform=this.jsonFormData.find(x=>x.type==this.selectedType && (x.subtype==this.selectedSubType || x.subtype==this.selectedType));
  if(!selectedform){
    this.displayError(`You must configure the config settings before saving the Data Writer config.`, 'Error');
    return;
  }
  const ftpError = this.dwFtpValidationError(false);
  if (ftpError) {
    this.displayWarning(ftpError, "Please fix the validation error.", "", (onClosed) => {});
    return;
  }
  // **Step 2: Validate Target Column Mappings for Source-Based Types**
  const sourceBasedTypes = ['file', 'excel', 'feather','parquet'];
  if(sourceBasedTypes.includes(this.selectedType)){
    if(this.isUseSource==false){
      for (const col of this.exportcolumninfo) {
        console.log(col.isinclude,col.name,col.targetcolumn);
        if(col.isinclude){
          if(col.targetcolumn=="" || col.targetcolumn==null){
            this.displayWarning("Please select target column mapping for included columns.", "Please fix the validation error.", "", (onClosed) => {});
            return;
          }
        }
      }
    }
    //validate directory path for file type
    const directoryField = selectedform.parameters.find(p => p.ukey == "1");
    const directoryPath = this.form.value[directoryField.name];
    if (!directoryPath || directoryPath.trim() === '') {
      this.displayWarning("Please select a directory path.", "Please fix the validation error.", "", (onClosed) => {});
      return;
    }
    // const datetimefield = selectedform.parameters.find(p => p.ukey == "0");
    // const datetimefieldvalue = this.form.value[datetimefield.name];
    // if (!datetimefieldvalue || datetimefieldvalue.trim() === '') {
    //   this.displayWarning("Please select a datetime field.", "Please fix the validation error.", "", (onClosed) => {});
    //   return;
    // }
  }
  // **Proceed with Saving**
  const busyIndicator = this.showBusyDialog('Please wait...');
  
  try {
      await this.onSubmit();
      this.snackBar.open("Successfully saved.", 'Dismiss', {
          duration: 5000
      });
  } catch (err) {
      this.displayError(`Failed to write '${this.selectedSubType}'`, 'Error', err);
  } finally {
      busyIndicator.close(); // Ensure the busy indicator closes even if an error occurs
  }
}
  
  
 browseDir(fieldname:string){
    console.log("browseDir....",fieldname);
    // Use FTP: the Export Directory is browsed on the selected SFTP service, once
    // its connection test has passed.
    const useFtp = this.isFtpUploadWriter && !!this.dwFtp?.useFtp;
    if (useFtp) {
      const ftpError = this.dwFtpValidationError(true);
      if (ftpError) {
        this.displayWarning(ftpError, "FTP Service", "", (onClosed) => {});
        return;
      }
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '750px';
    dialogConfig.data = useFtp
      ? {dataSourceTypeId: 1, supportedFileTypes: [], ftpServiceId: this.dwFtp.ftpServiceId}
      : {dataSourceTypeId: 1, supportedFileTypes: ['.csv', '.txt']};

    const dialogRef = this.matDialog.open(FolderBrowserDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result.selectedFileName) { return; }

      // File chosen is
      console.log('User selected to import file: ' + result.selectedFileName);
      //this.viewModel.inputFileName = result.selectedFileName;
      this.formGroup[fieldname] = new FormControl(result.selectedFileName);
      this.form = this.formBuilder.group(this.formGroup);
      // TODO: Determine why I need to invoke the below code to get UI reflecting the inputFileName
      //this.changeDet.detectChanges();
      // 🔥 Automatically update the file extension based on selection

      this.updateFileExtension(result.selectedFileName);
      // 🔥 Force UI update
    this.cdRef.detectChanges(); // <--- Add this line to reflect changes in the UI immediately
   
    });
  }
  updateFileExtension(selectedPath: string) {
    let extension = "";

    const lastSegment = selectedPath.split(/[\\/]/).pop() || "";

    console.log("lastSegment", lastSegment);

    if (selectedPath.endsWith(".csv")) {
        extension = ".csv";  
    } else if (selectedPath.endsWith(".txt")) {
        extension = ".txt";  
    } else if (lastSegment.toLowerCase() === "txt") {
        extension = ".txt";  
    } else if (lastSegment.toLowerCase() === "csv") {
        extension = ".csv";  
    }else if (lastSegment.toLowerCase() === "parquet") {
        extension = ".parquet";  
    }
     else {
        extension = ".txt";  
    }

   // console.log("extension==", extension);

    // 🔥 Find the Base Name field dynamically
    const baseNameField = this.formConfigjsonNext.find(x => x.ukey == "2"); // Base Name field
    if (!baseNameField) {
        console.warn("Base Name field does not exist.");
        return;
    }

    const baseNameValue = this.form.get(baseNameField.name)?.value || "";
    console.log("Base Name:", baseNameValue);

    // 🔥 Update the file name preview with the new extension
    this.updateFileName(baseNameValue, extension);
}

onUseSourceChanged(event: MatSlideToggleChange): void {
    if(event.checked){
      this.exportcolumninfo.forEach( r => r.targetcolumn = r.name);
    }else{
      this.exportcolumninfo.forEach( r => r.targetcolumn = '');
    }
  }


// updateFileName(newBaseName: string, newExtension: string): void {
//   if (!newBaseName) return;  // Avoid errors if empty

//   const timeExtension = this.formConfigjsonNext.find(x => x.ukey == "3")?.value || "";
//   const currentDate = new Date();
//   const timeextensionvalue = this.datePipe.transform(currentDate, timeExtension);

//   console.log("timeextensionvalue=",timeextensionvalue);

//   // 🔥 Use the extension dynamically (fallback to .txt)
//   const finalExtension = newExtension || ".txt";

//   // 🔥 Update the file name preview
//   const filenameField = this.formConfigjsonNext.find(x => x.ukey == "9");
//   if (filenameField) {
//       this.form.get(filenameField.name)?.setValue(`${newBaseName}_${timeextensionvalue}${finalExtension}`);

//       // 🔥 Force UI update
//       this.cdRef.detectChanges();
//   }

//   // 🔥 Update the label dynamically
//   const labelField = this.formConfigjsonNext.find(x => x.type === "label");
//   if (labelField) {
//       labelField.value = `${newBaseName}_${timeextensionvalue}${finalExtension}`;
//   }
// }
// updateFileName(newBaseName: string, newExtension: string = ""): void {
//   if (!newBaseName) return; // Avoid errors if empty

//   // 🔹 Get the currently selected DateTime extension (ukey=3) from the form
//   const dateField = this.formConfigjsonNext.find(f => f.ukey == "3");
//   const selectedExtension = dateField ? this.form.get(dateField.name)?.value || dateField.value : "yyyy-MM-dd";

//   // 🔹 Transform current date using the selected extension
//   const currentDate = new Date();
//   const timeextensionvalue = this.datePipe.transform(currentDate, selectedExtension);

//   console.log("Current date with selected extension:", timeextensionvalue);

//   // 🔹 Use provided extension or fallback to .txt
//   const finalExtension = newExtension || ".txt";

//   // 🔹 Update the file name preview field (ukey=9)
//   const filenameField = this.formConfigjsonNext.find(f => f.ukey == "9");
//   if (filenameField) {
//       const finalName = `${newBaseName}_${timeextensionvalue}${finalExtension}`;
//       this.form.get(filenameField.name)?.setValue(finalName);

//       // 🔹 Force UI update
//       this.cdRef.detectChanges();
//   }

//   // 🔹 Update any label dynamically if present
//   const labelField = this.formConfigjsonNext.find(f => f.type === "label");
//   if (labelField) {
//       labelField.value = `${newBaseName}_${timeextensionvalue}${finalExtension}`;
//   }
// }
updateFileName(newBaseName: string, newExtension: string = ""): void {
  if (!newBaseName) return; // Avoid errors if empty

  // Strip characters that Windows does not allow in file names: \ / : * ? " < > |
  const sanitized = newBaseName.replace(/[\\/:*?"<>|]/g, '');
  if (sanitized !== newBaseName) {
    const baseNameField = this.formConfigjsonNext.find(f => f.ukey == "2");
    if (baseNameField) {
      this.form.get(baseNameField.name)?.setValue(sanitized, { emitEvent: false });
    }
    newBaseName = sanitized;
  }

  // 🔹 Get the currently selected DateTime extension (ukey=3) from the form
  const dateField = this.formConfigjsonNext.find(f => f.ukey == "3");
  const rawExtension = dateField ? this.form.get(dateField.name)?.value || dateField.value : "yyyy-MM-dd";
  const selectedExtension = (rawExtension === 'none' || rawExtension === 'None') ? '' : rawExtension;

  // 🔹 Transform current date using the selected extension
  const currentDate = new Date();
  const timeextensionvalue = selectedExtension ? this.datePipe.transform(currentDate, selectedExtension) : '';

  console.log("Current date with selected extension:", timeextensionvalue);

  // 🔹 Pick extension based on type if not passed explicitly
  let finalExtension = newExtension;
  if (!finalExtension) {
    if (this.selectedType === "file") {
      const delimiterField = this.formConfigjsonNext.find(f => f.name?.toLowerCase().includes('delimiter') || f.label?.toLowerCase().includes('delimiter'));
      const delimiterValue = delimiterField ? (this.form.get(delimiterField.name)?.value || delimiterField.value || ',') : ',';
      finalExtension = delimiterValue === ',' ? '.csv' : '.txt';
    } else if (this.selectedType === "feather") {
      finalExtension = ".ftr";
    } else if (this.selectedType === "parquet") {
      finalExtension = ".parquet";
    } else {
      finalExtension = ".txt"; // fallback
    }
  }

  // 🔹 Update the file name preview field (ukey=9)
  const filenameField = this.formConfigjsonNext.find(f => f.ukey == "9");
  const timeSuffix = timeextensionvalue ? `_${timeextensionvalue}` : '';
  if (filenameField) {
    const finalName = this.isDisabled ? `${newBaseName}${finalExtension}` : `${newBaseName}${timeSuffix}${finalExtension}`;
    this.form.get(filenameField.name)?.setValue(finalName);

    // 🔹 Force UI update
    this.cdRef.detectChanges();
  }

  // 🔹 Update any label dynamically if present
  const labelField = this.formConfigjsonNext.find(f => f.type === "label");
  if (labelField) {
    labelField.value = `${newBaseName}${timeSuffix}${finalExtension}`;
  }
}


  exportDataWriter(){
    var node=this.userData.getSelectedNodeDetails();
    const currentDate = new Date();
    const filename = node.refineryConfigName+'-'+node.rcNo+'-'+node.name+'-'+this.datePipe.transform(currentDate, 'yyyy-MM-dd-hh-mm-ss')+'.json';
    this.jsonDownloadService.downloadJsonFile(this.jsonFormData, filename);
  }
  async importDataWriter(event: any){
    const file: File = event.target.files[0];
    const reader: FileReader = new FileReader();
    //console.log(file);
    reader.onload = async (e: any) => {
      const fileContent: string = e.target.result;
      this.jsonFormData = JSON.parse(fileContent);
      //console.log(this.jsonFormData);
      var configJson=this.userData.getSelectedRefineryDetails();
      var confignode=configJson.nodes.find(node=>node.id==this.userData.getSelectedNodeDetails().id);
      if(!this.selectedType){
        this.selectedType='file';
      }
      if(!this.selectedSubType){
        this.selectedSubType='file';
      }
      confignode.data.dbWriterType=this.selectedType;
      confignode.data.dbWriterSubType=this.selectedSubType;
      confignode.data.isdbupdater=false;
      confignode.data.dataWriter=this.jsonFormData;
      var refineryConfig = await this.configService.UpsertRefineryConfig(configJson);
      this.userData.setSelectedRefineryDetails(refineryConfig);
      this.initializeExportComponent();
    };
    reader.readAsText(file);
  }
  triggerFileInput(): void {
    const fileInput = document.getElementById('fileInput') as HTMLElement;
    fileInput.click();
  }

// Function to open the custom dialog
showColoredTextItemEditorDialog(
  title: string,
  textTypeName: string,
  existingItems: any[],
  fieldType: string,
  isDuplicateRemoved: boolean,
  options: string[],
  onClosed: (items: any[], eventname: string) => void
): void {
  const dialogConfig = new MatDialogConfig();
  dialogConfig.disableClose = true;
  dialogConfig.autoFocus = true;
  dialogConfig.width = '600px';

  // Pass selected data
  dialogConfig.data = { 
    items: existingItems, 
    textTypeName, 
    title, 
    fieldType, 
    isDuplicateRemoved, 
    options 
  };

  const dialogRef = this.matDialog.open(ContainsTextDialogOptionComponent, dialogConfig);

  dialogRef.afterClosed().subscribe(result => {
    if (result?.items) {
      onClosed(result.items, result.eventname);
    } else {
      console.log("Dialog closed without selection.");
    }
  });
}
selectedColumns: any[] = []; // Holds selected field values

onKeyFieldSelectCellClicked(): void {
  var fieldType: string = "dropdown"; // Type of input
  var isDuplicateRemoved: boolean = true; // Remove duplicate values
  var options: string[] = this.targetcolumnsValues.map(col => col.text); // Extract column names

  this.showColoredTextItemEditorDialog(
      'Target Table Additional Key Field Chooser',
      'Key Fields',
      this.selectedColumns,
      fieldType,
      isDuplicateRemoved,
      options,
      async (items: ColoredTextItem[], eventname: string) => {
          let validate = true;

          if (items && items.length > 0) {
              this.selectedColumns = [...items]; // Save selected values
              this.targetcolumnskeyfields = items.map(item => item.text);
          } else {
              // If no items are selected, show validation error
              validate = false;
              this.displayWarning(
                  "No Key Fields are selected, please add one or more.",
                  "Please fix the validation error.",
                  "",
                  (onClosed) => {
                      this.onKeyFieldSelectCellClicked();
                  }
              );
          }
//console.log(this.selectedColumns);
//console.log(this.targetcolumnskeyfields);
          // If event is 'save' and validation passed, assign items to rule fields
          if (eventname === 'save' && validate) {
            this.selectedColumns = [...items]; // Save selected values
            this.targetcolumnskeyfields = items.map(item => item.text);
          }
      }
  );
}


getColor(col: any): string {
    return col?.color?.color || 'inherit'; // Default color
}


async runAutoMapper(): Promise<void> {


      // **Step 1: Check if Table is Blank**
      if (!this.selectedtable) {
        console.log("Table is missing - showing warning");
        this.displayWarning("Please select a table.", "Please fix the validation error.", "", (onClosed) => {});
        return;
    }
    console.log("Table is selected, proceeding to check key fields.");
    if ((!this.primarykeyvalue || this.primarykeyvalue.trim() === '') && 
    (!this.targetcolumnskeyfields || this.targetcolumnskeyfields.length === 0)) {
    console.log("Key fields are missing - showing warning");
    this.displayWarning(
        "Please select at least one additional key field.", 
        "Please fix the validation error.", 
        "", 
        (onClosed) => {}
    );
    return;
    }
  try {
    var outputcoulumnrequest = new DataWriterMapRequest();
    outputcoulumnrequest.nodeID = this.userData.getSelectedNodeDetails().id;
    outputcoulumnrequest.refineryConfigID = this.userData.getSelectedNodeDetails().refineryConfigGuid;
    outputcoulumnrequest.columnMapperType = 1;
    outputcoulumnrequest.tableName = this.selectedtable;

    const outputcolumnsPrev = await this.configService.getColumnsDWV2(outputcoulumnrequest);
   // console.log("outputcolumnsPrev", outputcolumnsPrev);

    if (!outputcolumnsPrev || !outputcolumnsPrev.outputColumnList) {
      console.error("Error: outputcolumnsPrev.outputColumnList is undefined", outputcolumnsPrev);
      return;
    }

    if (!this.targetcolumns || !Array.isArray(this.targetcolumns)) {
      console.error("Error: this.targetcolumns is undefined or not an array", this.targetcolumns);
      return;
    }

    this.exportcolumninfo = outputcolumnsPrev.outputColumnList.map(ci => {
      let targetValue = (ci.targetcolumn || "").trim();
     // console.log("targetValue===", targetValue);

     // console.log("auto mapper target columns", this.targetcolumns);

      let matchedTarget = this.targetcolumns.find(tc => 
        tc?.text && targetValue ? tc.text.trim().toLowerCase() === targetValue.trim().toLowerCase() : false
      );

      //console.log("matchedTarget===", matchedTarget);

      return new ExportMapColumnInfo(
        ci.index,
        ci.name,
        ci.dataType,
        ci.description,
        ci.isinclude,
        matchedTarget ? matchedTarget.text : ""
      );
    });

    //console.log("Auto-mapped Columns:", this.exportcolumninfo);
    this.dataSourceExport = new MatTableDataSource<ExportMapColumnInfo>(this.exportcolumninfo);
    this.cdRef.detectChanges();
    this.displayInfo("Auto-mapping has been applied", "Auto Mapping Alert");
  } catch (error) {
    console.error("Error in runAutoMapper:", error);
  }
}


  async matchToPreviousMapping(): Promise<void> {
      // **Step 1: Check if Table is Blank**
      if (!this.selectedtable) {
        console.log("Table is missing - showing warning");
        this.displayWarning("Please select a table.", "Please fix the validation error.", "", (onClosed) => {});
        return;
    }
    console.log("Table is selected, proceeding to check key fields.");
    if ((!this.primarykeyvalue || this.primarykeyvalue.trim() === '') && 
    (!this.targetcolumnskeyfields || this.targetcolumnskeyfields.length === 0)) {
    console.log("Key fields are missing - showing warning");
    this.displayWarning(
        "Please select at least one additional key field.", 
        "Please fix the validation error.", 
        "", 
        (onClosed) => {}
    );
    return;
    }
    try {
      var outputcoulumnrequest = new DataWriterMapRequest();
      outputcoulumnrequest.nodeID = this.userData.getSelectedNodeDetails().id;
      outputcoulumnrequest.refineryConfigID = this.userData.getSelectedNodeDetails().refineryConfigGuid;
      outputcoulumnrequest.columnMapperType = 2;
      outputcoulumnrequest.tableName = this.selectedtable;
  
      const outputcolumnsPrev = await this.configService.getColumnsDWV2(outputcoulumnrequest);
      console.log("outputcolumnsPrev", outputcolumnsPrev);
  
      if (!outputcolumnsPrev || !outputcolumnsPrev.outputColumnList) {
        console.error("Error: outputcolumnsPrev.outputColumnList is undefined", outputcolumnsPrev);
        return;
      }
  
      if (!this.targetcolumns || !Array.isArray(this.targetcolumns)) {
        console.error("Error: this.targetcolumns is undefined or not an array", this.targetcolumns);
        return;
      }
  
      this.exportcolumninfo = outputcolumnsPrev.outputColumnList.map(ci => {
        let targetValue = (ci.targetcolumn || "").trim();
  
        let matchedTarget = this.targetcolumns.find(tc => 
          tc?.text && targetValue ? tc.text.trim().toLowerCase() === targetValue.trim().toLowerCase() : false
        );
  
        return new ExportMapColumnInfo(
          ci.index,
          ci.name,
          ci.dataType,
          ci.description,
          ci.isinclude,
          matchedTarget ? matchedTarget.value : ""
        );
      });
  
      console.log("Auto-mapped Columns:", this.exportcolumninfo);
      this.dataSourceExport = new MatTableDataSource<ExportMapColumnInfo>(this.exportcolumninfo);
      this.cdRef.detectChanges();
    
    } catch (error) {
      console.error("Error in runAutoMapper:", error);
    }


}
clearMap(): void {
  this.showConfirmDialog(
    'Clear Column Mapping', // Title of the dialog
    'Are you sure you want to clear the mapping?', // Message of the dialog
    async (result) => {
      if (result) { // Clear the mapping only if the analyst confirms (result is true)
       // this.isClearMapButtonClicked = true;
        //this.isAutoMapApplied = false;
       // this.sharedService.sendEvent("mapper_updated");
       // await this.loadColumns();  
       var outputcoulumnrequest =new DataWriterMapRequest();
       outputcoulumnrequest.nodeID=this.userData.getSelectedNodeDetails().id;
       outputcoulumnrequest.refineryConfigID=this.userData.getSelectedNodeDetails().refineryConfigGuid;
       outputcoulumnrequest.columnMapperType=3;
       outputcoulumnrequest.tableName=this.selectedtable;
     const outputcolumns = await this.configService.getColumnsDWV2(outputcoulumnrequest);
console.log("outputcolumns", outputcolumns);

// Ensure outputcolumns and outputcolumns.outputcolumnList exist
if (!outputcolumns || !outputcolumns.outputColumnList) {
  console.error("Error: outputcolumns.outputcolumnList is undefined", outputcolumns);
  return;
}

this.exportcolumninfo = [];

outputcolumns.outputColumnList.forEach(ci => {
  this.exportcolumninfo.push(new ExportMapColumnInfo(ci.index, ci.name, ci.dataType, ci.description, false, ""));
});

this.dataSourceExport = new MatTableDataSource<ExportMapColumnInfo>();
this.dataSourceExport.data = this.exportcolumninfo;
this.displayedColumnsExport = this.displayedColumnsExport;
this.cdRef.detectChanges();

       
      }
    }
  );
}
onExtensionChange(event: any) {
  const baseNameField = this.formConfigjsonNext.find(f => f.ukey == "2"); // ukey=2 holds base name
  const baseName = baseNameField ? this.form.get(baseNameField.name)?.value || "" : "";

  this.updateFileName(baseName);
}

onSelectFieldChange(field: any, value: string): void {
  if(field.name == 'overwriteMode' && value == 'append') {
      this.isDisabled = true;
  } else {
    this.isDisabled = false;
  }
  this.cdRef.detectChanges();
}

getSelectedOptionText(field: any): string {
  const value = this.form?.get(field.name)?.value;
  if(field.name == 'datetimefield') {
    //if (field.options == null || field.options == undefined) {
    if (this.selectdynamicsource == null || this.selectdynamicsource == undefined) {
       return 'currentDateTime'; // default to first option if options are missing
    }
  } 
  return field.options?.find((o: any) => o.value === value)?.text ?? value ?? '';
}
getIconClass(field: any): string | null {
  switch (field.name) {
    case 'database':
      return 'fa-solid fa-database';
    case 'file':
      return 'fa-solid fa-file';
    case 'excel':
      return 'fa-solid fa-file-excel';
    case 'feather':
      return 'fa-solid fa-feather';
    default:
      return 'fa-solid fa-circle-check'; // only text, no icon
  }
}

getStatusClass(status: string): string {
  return status === 'success' ? 'success-icon'
       : status === 'error'   ? 'error-icon'
       : status === 'warning' ? 'warning-icon'
       : '';
}

getStatusImageSrc(status: string): string | null {
  switch (status) {
    case 'success': return 'assets/images/status-success.png';
    case 'error':   return 'assets/images/status-error.png';
    case 'warning': return 'assets/images/status-warning.png';
    default:        return null;
  }
}

getIconImageSrc(field: any): string | null {
  if (field.name === 'parquet') {
    if (field.connstatus === 'success') return 'assets/images/parquet_icon_green.png';
    if (field.connstatus === 'error')   return 'assets/images/parquet_icon_red.png';
    return null;
    // return 'assets/images/parquet_icon_gray.png';
  }
  return null;
}

  handleMoveToField(direction: 'forward' | 'reverse',index: number, event: Event){
    event.preventDefault(); // 🔥 VERY IMPORTANT (prevents double tab)

    if (direction === 'reverse') {
      this.focusPreviousInput(index);
    } else {
      this.focusNextInput(index);
    }
  }

  focusNextInput(index: number) {
    const inputsArray = this.inputs.toArray();
    for (let i = index + 1; i < inputsArray.length; i++) {
      const el = inputsArray[i].nativeElement;

      if (!el.disabled) {   // ✅ skip disabled
        el.focus();
        el.scrollIntoView({ block: 'center' });
        break;
      }
    }
  }

  focusPreviousInput(index: number) {
    const inputsArray = this.inputs.toArray();
    for (let i = index - 1; i >= 0; i--) {
      const el = inputsArray[i].nativeElement;

      if (!el.disabled) {   // ✅ skip disabled
        el.focus();
        el.scrollIntoView({ block: 'center' });
        break;
      }
    }
  }
}
